export enum StatusEnum {
    ACTIVE = 'Active',
    INACTIVE = 'InActive'
}
